import { useSuspenseQuery } from '@tanstack/react-query';
import { getWidgetLayoutV2 } from '../../../../shared/service/widgetApi';
import { WidgetLayoutResponse } from '../../../../shared/types/widget';
import { useParams } from 'react-router-dom';

export default function useWidgetLayoutQuery(slugOverride?: string) {
  const { slug } = useParams<{ slug: string }>();

  const effectiveSlug = slugOverride || slug;

  const query = useSuspenseQuery<WidgetLayoutResponse>({
    queryKey: ['widgets', 'layout', effectiveSlug],
    queryFn: () => getWidgetLayoutV2(effectiveSlug),
    staleTime: 10 * 60 * 1000, // 10 minutes
  });

  return {
    ...query,
  };
}
